<template>
  <div class="dashboard-profile">
    <div id="content">
      <div class="register">
        <div class="">
          <div class="inner">
            <div class="main">
              <h3 class="title">Bank Account Information</h3>
              <div class="bank-info">
                <div class="box">
                  <div class="number">**** 7890</div>
                  <div class="bank-name">KASIKORN BANK</div>
                </div>
              </div>
              <div class="submit-button">
                <router-link to="/dashboard/user-profile_bank">
                  <button class="btn btn-outline" type="submit">Edit</button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "DashboardProfileBankAdded",
};
</script>
<style scoped lang="scss">
@import "@/assets/stylesheets/application";
@import "@/assets/stylesheets/register";
h3.title {
  color: $black;
}
.bank-info {
  padding: 1rem 0;
  .box {
    display: inline-block;
    width: 300px;
    padding: 1rem 1rem;
    background: #f4f4f4;
    border-radius: 8px;
    .number {
      font-size: 1.15em;
      text-align: right;
    }
    .bank-name {
      font-size: 12px;
      text-transform: uppercase;
    }
  }
}
.submit-button {
  .btn {
    padding: 0.75rem 2rem;
    /* stylelint-disable-next-line declaration-no-important */
    width: auto !important;
  }
}
@media only screen and (max-width: 991px) {
  .bank-info {
    padding: 1rem 0;
    .box {
      width: 100%;
      .number {
        font-size: 1em;
      }
      .bank-name {
        font-size: 12px;
      }
    }
  }
}
</style>
